import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileLines, faCalendarCheck, faUserCheck, faReply, faImages, faShieldHalved, faLock, faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

import { WaCornerLogo, WaFooter } from '../whatsapp/layout/WaChrome';

// The Terms of Service and the Privacy Policy are two sections of one page, public/wa-privacy-policy.html
const POLICY_PAGE = `${process.env.PUBLIC_URL || ''}/wa-privacy-policy.html`;

// What the WhatsApp side of the platform does for a business, in the order they usually come up.
const FEATURES = [
  { icon: faFileLines, label: 'Templates', text: 'Approved, with variables' },
  { icon: faCalendarCheck, label: 'Scheduling', text: 'Send now or later' },
  { icon: faUserCheck, label: 'Consent', text: 'Opt-in and opt-out' },
  { icon: faReply, label: 'Replies', text: 'Button taps tracked' },
  { icon: faImages, label: 'Rich media', text: 'Images and documents' },
  { icon: faShieldHalved, label: 'Secure', text: 'Encrypted and audited' },
];

const LoginPage = () => {
  /**
   * In 2026 BFF Pattern:
   * 1. REMOVED: useAuthContext and authService.
   * 2. REMOVED: useEffect redirect (ProtectedRoute now handles session verification).
   * 3. LOGIN: We redirect the browser to the Gateway's OAuth2 initiation path.
   */
  const handleLogin = () => {
    // This points to the standard Spring Security OAuth2 client initiation path on your Gateway
    window.location.href = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/oauth2/authorization/gateway-client`;
  };

  // The same corner logo (header) and footer as the WhatsApp pages, around the welcome in a framed card. No top bar: its buttons
  // (My User Profile, Logout, Dashboard) are for a signed-in user.
  return (
    <div className="wa-dashboard-page">
      <WaCornerLogo />
      <div className="wa-dashboard-inner">
        <main className="login-main">
          <section className="wa-dash-card login-card" aria-label="Log in">
            <h1 className="login-heading">Welcome to Primedha Connect</h1>
            <p className="login-subtitle">Log in to send, schedule and track your WhatsApp messages.</p>

            <ul className="login-features" aria-label="What you can do">
              {FEATURES.map(({ icon, label, text }) => (
                <li key={label} className="login-feature">
                  <span className="login-feature-icon"><FontAwesomeIcon icon={icon} aria-hidden="true" /></span>
                  <span className="login-feature-label">{label}</span>
                  <span className="login-feature-text">{text}</span>
                </li>
              ))}
            </ul>

            <button type="button" className="login-button" onClick={handleLogin}>
              <FontAwesomeIcon icon={faLock} className="login-button-icon" aria-hidden="true" />Log In via Secure Gateway
            </button>

            <p className="login-note">
              <FontAwesomeIcon icon={faCircleCheck} className="login-note-icon" aria-hidden="true" />
              Your password is entered on the secure sign-in page, never in this app.
            </p>
            <p className="login-legal">
              By logging in you agree to the{' '}
              <a href={`${POLICY_PAGE}#terms`} target="_blank" rel="noopener noreferrer">Terms of Service</a> and the{' '}
              <a href={`${POLICY_PAGE}#privacy`} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p>
          </section>
        </main>

        <nav className="login-legal-nav" aria-label="Legal">
          <a href={`${POLICY_PAGE}#terms`} target="_blank" rel="noopener noreferrer">Terms of Service</a>
          <a href={`${POLICY_PAGE}#privacy`} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <Link to="/pricing" target="_blank" rel="noopener noreferrer">Pricing</Link>
        </nav>

        <WaFooter />
      </div>
    </div>
  );
};

export default LoginPage;
